export const STYLES_DICTIONARY_ID = 2;